export const SPINE_REGIONS = [
  {
    id: "neck",
    label: "Neck",
    segment: "Cervical · C1–C7",
    color: "#0EA5E9",
    soft: "#E0F2FE",
    ink: "#0369A1",
    blurb: "Seven small vertebrae support your head through every glance down at a phone or screen.",
    conditions: ["neck-pain", "slip-disc", "posture", "ergonomics"],
  },
  {
    id: "upper",
    label: "Upper back",
    segment: "Thoracic · T1–T12",
    color: "#1D6FD8",
    soft: "#DBEAFE",
    ink: "#014E96",
    blurb: "Twelve vertebrae anchor your ribs and shoulders, and often take the strain of slouching and desk work.",
    conditions: ["posture", "shoulder-joint", "ergonomics"],
  },
  {
    id: "lower",
    label: "Lower back",
    segment: "Lumbar · L1–L5",
    color: "#539323",
    soft: "#E3F1D6",
    ink: "#36611A",
    blurb: "Five large vertebrae carry much of your body weight as you sit, bend and lift.",
    conditions: ["back-pain", "slip-disc", "sciatica"],
  },
  {
    id: "pelvis",
    label: "Pelvis",
    segment: "Sacrum & coccyx",
    color: "#F97316",
    soft: "#FFEDD5",
    ink: "#C2410C",
    blurb: "The base of the spine, close to the nerves that travel down into the legs.",
    conditions: ["sciatica", "back-pain"],
  },
];
